import { Swiper } from 'swiper';
import {Navigation, Pagination} from "swiper/modules";
Swiper.use([Navigation, Pagination]);

export default () => {
    const nodeSelectors = {
        container: '[js-reviews-slider="container"]',
        slider: '[js-reviews-slider="slider"]',
        pagination: '[js-reviews-slider="pagination"]',
        prev: '[js-reviews-slider="prev"]',
        next: '[js-reviews-slider="next"]',
        play: '[js-reviews-slider-play="play-button"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)
        console.log('radi')

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let reviewsSlider = new Swiper(sliderEl, {
                spaceBetween: 0,
                slidesPerView: 1,
                loop: true,
                speed: 500,
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                pagination: {
                    el: container.querySelector(nodeSelectors.pagination),
                }
            });
        })
    }

    return Object.freeze({
        init,
    })
}